<template>
  <path
    d="M12 15.4102L18 9.41016L16.59 8.00016L12 12.5802L7.41 8.00016L6 9.41016L12 15.4102Z"
    fill="#222B2F"
  />
</template>
